import { useState } from "react";
import axios from "axios";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { DetailDrawer } from "@/components/admin/ui";

const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400";
const inputClass = "mt-1 block w-full rounded-lg border border-slate-200 px-3 py-2 text-sm dark:border-white/15 dark:bg-[#0B1220] dark:text-white";
const btn = "inline-flex items-center gap-1.5 rounded-xl border border-transparent bg-[#0052FF] px-3.5 py-2 text-xs font-bold text-white transition-colors duration-150 hover:bg-[#0040CC] disabled:cursor-not-allowed disabled:opacity-50";
const outlineBtn = "inline-flex items-center gap-1.5 rounded-xl border border-slate-200 px-3.5 py-2 text-xs font-bold text-slate-600 transition-colors duration-150 hover:bg-slate-50 dark:border-white/15 dark:text-slate-300 dark:hover:bg-white/10";

export const AddCustomerModal = ({ API, onClose, onSaved }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true); setError("");
    try {
      await axios.post(`${API}/org/billing/customers`, { first_name: firstName, last_name: lastName, email: email || null, phone: phone || null }, { withCredentials: true });
      onSaved();
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); } finally { setSaving(false); }
  };

  return (
    <DetailDrawer open onClose={onClose} title="Add Customer" subtitle="Creates a canonical customer record shared across Nova Opsis." testId="billing-add-customer-drawer">
      <div className="space-y-4" data-testid="billing-add-customer-form">
        {error && <p className="text-sm font-semibold text-red-600 dark:text-red-400" data-testid="billing-add-customer-error">{error}</p>}
        <div className="grid gap-3 sm:grid-cols-2">
          <div><label className={labelClass}>First Name</label><input value={firstName} onChange={(e) => setFirstName(e.target.value)} data-testid="billing-add-customer-first-name" className={inputClass} /></div>
          <div><label className={labelClass}>Last Name</label><input value={lastName} onChange={(e) => setLastName(e.target.value)} data-testid="billing-add-customer-last-name" className={inputClass} /></div>
        </div>
        <div><label className={labelClass}>Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="billing-add-customer-email" className={inputClass} /></div>
        <div><label className={labelClass}>Phone</label><input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="billing-add-customer-phone" className={inputClass} /></div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} data-testid="billing-add-customer-cancel" className={outlineBtn}>Cancel</button>
          <button type="button" onClick={submit} disabled={saving || !firstName.trim() || !lastName.trim()} data-testid="billing-add-customer-save" className={btn}>Add Customer</button>
        </div>
      </div>
    </DetailDrawer>
  );
};
